import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberServicesEscalations as MemberServicesEscalations } from 'ui/views/widgets/memberServicesEscalations';
 *
 * // render
 * <MemberServicesEscalations propName='propValue'/>
 */
export const memberServicesEscalations = ( props ) => {
    return (
        <div className='ui-member-services-escalations'>
            <div className='ui-member-services-escalations__header'>
				{ /* title for the modal */ }
				<div className='ui-member-services-escalations__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-member-services-escalations__body'>
                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.state.values } // default values
                    isValid={ false }
                    mode='form'
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( {
                                category: values.category,
                                type: values.type,
                                dateMemberCalled: values.dateMemberCalled,
                                goLiveRelated: values.goLiveRelated,
                                priority: values.priority,
                                dueDate: values.dueDate,
                                shortDescription: values.shortDescription,
                                description: values.description
                            } );
                        }
                    } }
                >
                    { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {
                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-member-services-escalations__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    
                                    return (
                                        <field.view
                                            className={classnames( 'ui-member-services-escalations__body__form__field', `ui-member-services-escalations__body__form__${field.name}` )}
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.options, field.options ) }
                                            allowFilter={ 'state' === field.name }
                                            config={ field.config }
                                        />
                                    );
                                } ) }
                                {/* button actions */}
                                <div className='ui-member-services-escalations__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                disabled={ 'cancel' !== action.name ? !isValid : false }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-member-services-escalations__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                    // popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
        </div>
    );
};

// set display name
memberServicesEscalations.displayName = 'memberServicesEscalations';

// set default props
memberServicesEscalations.defaultProps = {};

// prop types
memberServicesEscalations.propTypes = {};
